/**
 * LIS Webapps API
 * Communication
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PackageTimesDTO { 
    id?: string;
    senderName?: string;
    senderZip?: string;
    senderCity?: string;
    pickup?: string;
    delivery?: string;
    expected?: string;
}

